export const weighbridgeOpsUr = {
  weighbridgeOps: {
    title: 'وی برج آپریشنز',
    subtitle: 'لائیو اسکیل مانیٹرنگ اور وزن کیپچر',
    connection: {
      connected: 'جڑا ہوا',
      connecting: 'جڑ رہا ہے...',
      reconnecting: 'دوبارہ جڑ رہا ہے...',
      disconnected: 'منقطع',
      noInternet: 'انٹرنیٹ نہیں',
    },
    stage: {
      firstWeight: 'پہلا وزن',
      secondWeight: 'دوسرا وزن',
    },
    gate: {
      entry: 'انٹری گیٹ',
      exit: 'ایگزٹ گیٹ',
      open: 'کھلا',
      closed: 'بند',
      openBtn: 'کھولیں',
      closeBtn: 'بند کریں',
      notConfigured: 'کنفیگر نہیں ہے',
      openAria: 'کھولیں',
      closeAria: 'بند کریں',
    },
    panel: {
      firstWeight: 'پہلا وزن',
      secondWeight: 'دوسرا وزن',
      idle: 'ٹرک کا انتظار',
      capturing: 'کیپچر ہو رہا ہے...',
      captured: 'وزن کیپچر ہو گیا',
      capturedAt: 'کیپچر وقت',
      error: 'کیپچر ناکام',
      captureButton: 'وزن کیپچر کریں',
      override: 'اوورائڈ — ابھی کیپچر کریں',
      weightUnit: 'کلوگرام',
      adminOverrideTitle: 'ایڈمن اوورائڈ — وزن دستی طور پر درج کریں',
      weightPlaceholder: 'وزن درج کریں (کلوگرام)',
      setWeight: 'وزن سیٹ کریں',
      enterOrderFirst: 'پہلے آرڈر نمبر درج کریں',
      saveContinue: 'محفوظ کریں اور آگے بڑھیں',
      saving: 'محفوظ ہو رہا ہے…',
      clearWeight: 'صاف کریں',
      zeroCheck: {
        title: 'اسکیل چیک',
        reading: 'اسکیل {{weight}} کلوگرام دکھا رہا ہے — صفر کا انتظار',
      },
      stageLocked: 'مرحلہ مقفل',
      stageLockedByOrder: '— آرڈر {{orderNumber}} کی خرابی۔',
      stageLockedOpenGate: 'ایگزٹ گیٹ کھولیں تاکہ قفل ہٹے۔',
      stageLockedTitle: 'آرڈر {{orderNumber}} نے قفل کیا — ایگزٹ گیٹ کھولیں',
      stageLockedTitleNoOrder: 'مرحلہ مقفل — ایگزٹ گیٹ کھولیں',
      lockedBadge: 'مقفل · {{orderNumber}}',
      lockedBadgeNoOrder: 'مقفل',
      inQueueBadge: '{{count}} قطار میں',
      overweightWarning: {
        title: 'انتباہ: وزن میں فرق',
        description:
          'خالص وزن {{netWeight}} منصوبہ بند {{plannedWeight}} سے {{deltaKg}} کجم مختلف ہے۔',
      },
      overweightConfirm: {
        title: '⚠ وزن میں فرق — کارروائی درکار ہے',
        description:
          'خالص وزن {{netWeight}} کجم منصوبہ بند {{plannedWeight}} کجم سے {{deltaKg}} کجم مختلف ہے۔ آگے کیسے بڑھنا چاہتے ہیں؟',
        continueBtn: 'جاری رکھیں اور جمع کریں',
        rejectBtn: 'مسترد کریں اور چھوڑیں',
      },
      recordedWeights: 'ریکارڈ شدہ اوزان',
      tare: 'خالی وزن',
      gross: 'کل وزن',
      net: 'خالص وزن',
      liveWeightSummary: {
        title: 'وزن خلاصہ',
        tare: 'خالی وزن (پہلا)',
        gross: 'کل وزن (دوسرا)',
        inboundGross: 'کل وزن (پہلا)',
        inboundTare: 'خالی وزن (دوسرا)',
        net: 'خالص وزن',
        noTare: 'اس آرڈر کا خالی وزن ابھی تک ریکارڈ نہیں ہوا',
        noGross: 'اس شپمنٹ کا کل وزن ابھی تک ریکارڈ نہیں ہوا',
      },
    },
    queue: {
      title: 'فعال قطار',
      empty: 'قطار میں کوئی ٹرک نہیں',
      manualEntry: 'دستی آرڈر نمبر',
      manualInboundEntry: 'دستی شپمنٹ نمبر',
      manualPlaceholder: 'آرڈر نمبر (فال بیک)',
      manualInboundPlaceholder: 'شپمنٹ نمبر',
      inbound: 'ان باؤنڈ',
      outbound: 'آؤٹ باؤنڈ',
      orderNumber: 'آرڈر',
      shipmentNumber: 'شپمنٹ',
      waitJustNow: 'ابھی',
      waitSeconds: '{{secs}} سیکنڈ',
      waitMinutesSeconds: '{{mins}} منٹ {{secs}} سیکنڈ',
      statusActive: 'فعال',
      statusWaiting: 'انتظار',
      removeFromQueue: 'قطار سے ہٹائیں',
      removeFromQueueTitle: 'آرڈر {{orderNumber}} قطار میں ہے — ہٹانے کے لیے کلک کریں',
      driver: 'ڈرائیور',
      plate: 'گاڑی کی پلیٹ',
      firstWeight: 'پہلا وزن',
      secondWeight: 'دوسرا وزن',
      firstWeightLabel: 'و1',
      secondWeightLabel: 'و2',
      packagingBags: 'بوری',
      packagingBulk: 'بلک',
      plannedWeight: 'منصوبہ بند وزن',
      plannedWeightValue: '{{weight}} کلوگرام',
      weightPending: '—',
      loadingDetails: 'تفصیلات لوڈ ہو رہی ہیں...',
    },
    history: {
      title: 'سیشن ہسٹری',
      empty: 'ابھی کوئی واقعات نہیں',
      clearButton: 'صاف کریں',
      sinceNote: 'کنکشن کھلنے کے بعد سے — صرف میموری میں',
      connected: 'وی برج کنٹرولر سے جڑ گئے',
      disconnected: 'کنٹرولر سے منقطع ہو گئے',
      internetConnected: 'انٹرنیٹ کنکشن بحال ہو گیا',
      internetDisconnected: 'انٹرنیٹ کنکشن ختم ہو گیا',
      orderQueued: '{{flowLabel}} {{identifier}} کو {{source}} کے ذریعے قطار میں شامل کیا گیا — {{stage}}',
      orderEnqueued: '{{flowLabel}} {{identifier}} انتظار میں ہے — {{stage}}',
      captureStarted: '{{stage}} کیپچر شروع ہوا{{orderSuffix}}',
      weightCaptured: '{{stage}} نے {{weight}} کلوگرام کیپچر کیا{{orderSuffix}}',
      weightSaved: '{{stage}} محفوظ ہو گیا: {{weight}} کلوگرام{{orderSuffix}}',
      captureError: '{{stage}} میں خرابی: {{error}}{{orderSuffix}}',
      gateChanged: '{{gate}} گیٹ {{status}}{{stageSuffix}}',
      anprDetected: 'ANPR: {{plate}}{{orderSuffix}}',
      scaleNotClear: 'اسکیل صاف نہیں ({{weight}} کلوگرام) — کوشش {{attempt}}/{{maxAttempts}}',
      scaleCleared: 'اسکیل صاف — تیار',
      truckDeparted: 'ٹرک روانہ ہو گیا — ایگزٹ گیٹ بند',
      sourceQrScan: 'QR اسکین',
      sourceAnpr: 'ANPR',
      sourceManual: 'دستی اندراج',
      stageLocked: '⚠️ {{stage}} مقفل — {{flowLabel}} {{identifier}} کی خرابی۔ ایگزٹ گیٹ کھولیں۔',
      stageUnlocked: '✅ {{stage}} کا قفل کھل گیا — معمول کا آپریشن دوبارہ شروع۔',
      captureRequestFailed: 'کیپچر کی درخواست ناکام: {{error}}',
      bootSnapshot: 'صفحہ لوڈ پر کنٹرولر کی حالت کا خلاصہ',
      bootLog: '📋 {{message}}',
      gateOpenFailed: 'گیٹ کھولنا ناکام: {{error}}',
      gateOpenError: 'گیٹ کھولنے میں خرابی: {{error}}',
      gateCloseFailed: 'گیٹ بند کرنا ناکام: {{error}}',
      gateCloseError: 'گیٹ بند کرنے میں خرابی: {{error}}',
      saveNoController: 'محفوظ کرنا ناکام: کنٹرولر URL کنفیگر نہیں ہے',
      saveSubmitted: '{{stage}} محفوظ جمع: {{weight}} کلوگرام ({{orderNumber}})',
      saveFailed: 'محفوظ کرنا ناکام: {{error}} ({{orderNumber}})',
      overweightConfirmRequired: '⚠️ زیادہ وزن کا پتہ چلا — آپریٹر کی کارروائی درکار ہے',
    },
    zone: {
      loading: 'وے برج زون لوڈ ہو رہا ہے...',
      noZone: 'اس فیکٹری کے لیے کوئی وے برج زون نہیں ملا۔',
      noController: 'زون میں کنٹرولر URL کنفیگر نہیں ہے۔',
      noTenantOrFactory: 'آپ کے اکاؤنٹ سے کوئی ٹیننٹ یا فیکٹری منسلک نہیں ہے۔',
    },
    errors: {
      fetchZoneFailed: 'وے برج زون لوڈ کرنے میں ناکامی',
      flowBusy: 'ویبرج مصروف ہے۔ براہ کرم انتظار کریں اور دوبارہ کوشش کریں۔',
      flowBusyOrder: 'ویبرج آرڈر {{orderNumber}} پر کام کر رہا ہے۔ براہ کرم انتظار کریں۔',
      // Fulfillment controller / service
      orderNumberRequired: 'آرڈر نمبر ضروری ہے',
      tareWeightRequired: 'خالی وزن ضروری ہے',
      grossWeightRequired: 'کل وزن ضروری ہے',
      licensePlateRequired: 'لائسنس پلیٹ ضروری ہے',
      firstWeighFailed: 'پہلا وزن ریکارڈ کرنے میں ناکامی',
      secondWeighFailed: 'دوسرا وزن ریکارڈ کرنے میں ناکامی',
      validateOrderFailed: 'آرڈر تصدیق میں ناکامی',
      resolveByPlateFailed: 'پلیٹ سے آرڈر تلاش کرنے میں ناکامی',
      orderNotFound: 'آرڈر نہیں ملا',
      shipmentNotFound: 'اس آرڈر کی شپمنٹ نہیں ملی',
      tareWeightImmutable: 'کل وزن ریکارڈ ہونے کے بعد خالی وزن تبدیل نہیں کیا جا سکتا',
      netWeightInvalid: 'خالص وزن صفر سے زیادہ ہونا چاہیے',
      orderAlreadyProcessing: 'آرڈر پہلے سے پراسیسنگ میں ہے',
      orderStatusInvalid: 'آرڈر پراسیس نہیں ہو سکتا — درکار حالت میں نہیں',
      orderStatusNotProcessing: 'آرڈر کی حالت پراسیسنگ ہونی چاہیے',
      shipmentResourceRequired: 'پراسیسنگ شروع کرنے سے پہلے شپمنٹ ریسورس ضروری ہے',
      shipmentNotLoading: 'دوسرے وزن کے لیے شپمنٹ لوڈنگ حالت میں ہونی چاہیے',
      firstWeighRequired: 'دوسرے وزن سے پہلے پہلا وزن (خالی وزن) مکمل ہونا ضروری ہے',
      firstWeighAlreadyCompleted: 'اس شپمنٹ کا پہلا وزن پہلے ہی مکمل ہو چکا ہے',
      firstAndSecondWeighRequired: 'خروج سے پہلے پہلا اور دوسرا وزن مکمل ہونا ضروری ہے',
      bagsVarianceNotConfigured: 'اس ویریئنٹ کے لیے بیگ تغیر چیک کنفیگر نہیں ہے',
      bagsWeightVarianceExceeded: 'وزن کا تغیر {{variancePercent}}% کی اجازت شدہ حد {{thresholdPercent}}% سے زیادہ ہے۔ منصوبہ بند: {{plannedTonnes}}ٹ، اصل: {{actualTonnes}}ٹ',
      contractOverload: 'دوسرے وزن پر کنٹریکٹ اوورلوڈ روک دیا گیا۔ اوورلوڈ لاگت {{actualCost}} دستیاب کنٹریکٹ بیلنس {{availableBalance}} سے زیادہ ہے۔ کمی: {{deficit}}۔',
      assetNotFoundForPlate: 'اس لائسنس پلیٹ کے لیے کوئی فعال اثاثہ نہیں ملا',
      assetNotInResource: 'اثاثہ ملا لیکن کسی فعال ریسورس میں شامل نہیں',
      resourceNotInShipment: 'ریسورس ملا لیکن کسی شپمنٹ میں شامل نہیں',
      noOrderForPlate: 'اس گاڑی کی پلیٹ کے لیے کوئی فعال آرڈر نہیں ملا',
      resourceNotFound: 'منتخب ریسورس نہیں ملا',
      tenantRequired: 'ریسورس تفویض کرنے کے لیے ٹیننٹ درکار ہے',
      // Edge command controller
      siteIdRequired: 'سائٹ ID ضروری ہے',
      pollCommandsFailed: 'کمانڈ پول کرنے میں ناکامی',
      invalidCommandStatus: 'کمانڈ کی حالت مکمل یا ناکام ہونی چاہیے',
      edgeCommandNotFound: 'ایج کمانڈ نہیں ملی',
      edgeCommandAlreadyAcked: 'کمانڈ پہلے سے تسلیم کی جا چکی ہے',
      ackCommandFailed: 'کمانڈ تسلیم کرنے میں ناکامی',
      // QR scan controller / service
      zoneCodeRequired: 'زون کوڈ ضروری ہے',
      pathIdRequired: 'پاتھ ID ضروری ہے',
      gateNotFound: 'اس اسکین کے لیے گیٹ نہیں ملا',
      gateDirectionNotConfigured: 'گیٹ میں داخل یا خروج کا رخ کنفیگر نہیں',
      weighbridgeZoneNotAllowed: 'ویبرج زون اس قسم کے داخلے کے لیے اجازت نہیں',
      employeeNotFound: 'ملازم نہیں ملا یا فعال نہیں',
      orderNoFactory: 'آرڈر میں کوئی فیکٹری مخصوص نہیں',
      gateNoFactory: 'گیٹ میں کوئی فیکٹری مخصوص نہیں',
      factoryMismatch: 'فیکٹری مماثل نہیں — گاڑی مختلف فیکٹری میں رجسٹرڈ ہے',
      orderNoId: 'آرڈر کا عددی ID نہیں',
      queueTicketRequired: 'قطار کی ٹکٹ ضروری ہے۔ کیوسک پر قطار میں شامل ہوں۔',
      sapSalesOrderRequired: 'SAP سیلز آرڈر نہیں بنا۔ کیوسک پر دوبارہ قطار میں شامل ہوں۔',
      noAuthorizedAccess: 'اس نمبر پلیٹ کے لیے کوئی مجاز رسائی نہیں ملی',
      visitCannotCheckIn: 'داخلہ رد — وزٹ ابھی منظور یا شیڈول نہیں ہوئی',
      visitBlacklisted: 'داخلہ رد — زائر پابندی فہرست میں شامل ہے',
      visitTooEarly: 'داخلہ رد — گاڑی مقررہ وقت سے پہلے پہنچی',
      visitExpired: 'داخلہ رد — وزٹ کی اجازت کی مدت ختم ہو گئی',
      visitCannotCheckOut: 'چیک آؤٹ نہیں ہو سکتا — چیک ان نہیں ہوا',
      // Camera controller / service
      noGateForCamera: 'اس کیمرے سے کوئی گیٹ منسلک نہیں',
      cannotResolveFactory: 'آرڈر سے فیکٹری نہیں ملی',
      factoryNotFound: 'فیکٹری نہیں ملی',
      invalidLicensePlate: 'لائسنس پلیٹ کی شکل غلط ہے',
      gateDirectionMismatch: 'گیٹ کا رخ مماثل نہیں',
      // Additional keys
      cameraReadingFailed: 'کیمرہ ریڈنگ پروسیس کرنے میں ناکامی',
      gateResolveFailed: 'اس اسکین کے لیے گیٹ نہیں مل سکا',
      gateNoDirection: 'گیٹ کا داخلہ یا خروج کا رخ مقرر نہیں',
      weighbridgeZoneForbiddenEmployee: 'ویبرج زون میں ملازمین کا داخلہ ممنوع ہے',
      weighbridgeZoneForbiddenVisitor: 'ویبرج زون میں مہمانوں کا داخلہ ممنوع ہے',
      licensePlateInvalid: 'لائسنس پلیٹ کی شکل درست نہیں',
      weighbridgeMeasurementsMissing: 'خروج ممکن نہیں — ویبرج کی ضروری پیمائش غائب ہے',
      weighbridgeNoStage: 'ویبرج گیٹ کا کوئی وزن مرحلہ مقرر نہیں',
      queueExitFailed: 'قطار کی جگہ خالی کرنے میں ناکامی — دوبارہ کوشش کریں',
      scaleNotClear: 'اسکیل صاف نہیں — پلیٹ فارم پر کوئی اور ٹرک ہو سکتا ہے۔ دوبارہ کوشش سے پہلے چیک کریں۔',
      // Scan / assign-resource / fulfillment controller
      scanFailed: 'آرڈر اسکین کرنے میں ناکامی',
      suggestResourcesFailed: 'وسائل تجویز کرنے میں ناکامی',
      assignResourceFailed: 'وسائل تفویض کرنے میں ناکامی',
      resourceRequired: 'وسیلہ درکار ہے',
      licensePlateOrPhoneRequired: 'لائسنس پلیٹ یا ڈرائیور فون درکار ہے',
      startProcessingFailed: 'آرڈر پروسیسنگ شروع کرنے میں ناکامی',
      generatePdfFailed: 'آرڈر PDF بنانے میں ناکامی',
      syncInvoicesFailed: 'آرڈر کے انوائس سنک کرنے میں ناکامی',
      fetchLifecycleFailed: 'آرڈر لائف سائیکل لوڈ کرنے میں ناکامی',
      markDeliveredFailed: 'شپمنٹ کو ڈیلیور شدہ نشان کرنے میں ناکامی',
      noAssetType: 'کوئی فعال اثاثہ قسم نہیں ملی۔ براہ کرم کم از کم ایک اثاثہ قسم ترتیب دیں۔',
      invalidAssetType: 'اثاثہ قسم کی ترتیب غلط ہے',
      cannotDeliverCancelledShipment: 'منسوخ شدہ شپمنٹ کو ڈیلیور شدہ نشان نہیں کیا جا سکتا',
      createResourceFailed: 'وسیلہ بنانے میں ناکامی',
      createDriverFailed: 'ڈرائیور بنانے میں ناکامی',
      createVehicleFailed: 'گاڑی بنانے میں ناکامی',
      // Gate / scale hardware errors (from weighbridge-controller)
      zkbioUnreachable: 'ZKBio گیٹ ڈیوائس سے رابطہ ممکن نہیں',
      zkbioInvalidResponse: 'ZKBio ڈیوائس سے غلط جواب',
      zkbioGateError: 'ZKBio گیٹ خرابی',
      gateOpenFailed: 'گیٹ کھولنے میں ناکامی',
      gateCloseFailed: 'گیٹ بند کرنے میں ناکامی',
      gateAcknowledgeFailed: 'گیٹ نے کمانڈ کی تصدیق نہیں کی',
      gateStatusIsapiFailed: 'گیٹ کی حالت پڑھنے میں ناکامی',
      gateStatusFailed: 'گیٹ کی حالت پڑھنے میں ناکامی',
      scaleReadFailed: 'اسکیل ریڈنگ ناکام: زیادہ سے زیادہ کوششیں ختم ہو گئیں',
      // Command payload errors
      missingGateIp: 'گیٹ کا IP پتہ ترتیب نہیں دیا گیا',
      invalidDirection: 'سمت inbound یا outbound ہونی چاہیے',
      unsupportedShipmentId:
        'ان باؤنڈ ویبرج فلو میں shipment ID سپورٹ نہیں ہے۔ اس کے بجائے shipment number استعمال کریں۔',
      mixedIdentifiers:
        'یا تو آؤٹ باؤنڈ آرڈر نمبر استعمال کریں یا ان باؤنڈ شپمنٹ نمبر، دونوں نہیں۔',
      missingOrderNumber: 'آرڈر نمبر درکار ہے',
      missingShipmentNumber: 'شپمنٹ نمبر درکار ہے',
      missingWeightStage: 'وزن مرحلہ first_weight یا second_weight ہونا چاہیے',
      invalidWeight: 'وزن غیر منفی عدد ہونا چاہیے',
      orderAlreadyQueued: 'یہ آرڈر پہلے سے اس زون میں قطار میں ہے',
      zoneLocked: 'وے برج زون مقفل ہے — ان لاک کرنے کے لیے ایگزٹ گیٹ کھولیں',
      zoneBusy: 'وے برج زون مصروف ہے — براہ کرم انتظار کریں',
      controllerRequestFailed: 'ویٹ برج کنٹرولر سے رابطہ نہیں ہو سکا۔',
      // Hardware controller errors
      cameraEventFailed: 'کیمرہ ایونٹ پروسیس کرنے میں ناکامی',
      qrScanFailed: 'QR اسکین پروسیس کرنے میں ناکامی',
      // ZKBio gate / door poller
      zkbioOpenFailed: 'گیٹ {{gateCode}} کھولنا ناکام ہوا',
      zkbioDoorTimeout: 'گیٹ مقررہ وقت میں بند نہیں ہوا',
      // ANPR / camera
      anprMissingPlate: 'کیمرے کی ریڈنگ میں نمبر پلیٹ نہیں ملی',
      anprRejected: 'سرور نے کیمرے کی ریڈنگ مسترد کردی',
      anprForwardFailed: 'کیمرے کی ریڈنگ سرور کو بھیجنے میں ناکامی',
      // QR scan
      qrMissingOrderNumber: 'QR اسکین میں آرڈر نمبر شامل نہیں',
      qrRejected: 'سرور نے QR اسکین مسترد کردیا',
      qrForwardFailed: 'QR اسکین سرور کو بھیجنے میں ناکامی',
      // Weighbridge flow
      duplicateFlow: 'آرڈر {{orderNumber}} پہلے سے اس مرحلے میں جاری ہے',
      orderAlreadyWeighed:
        '{{orderNumber}} کے لیے یہ وزن پہلے ہی ریکارڈ ہو چکا ہے',
      weightSubmissionFailed: 'وزن جمع کرنا ناکام — {{flowLabel}} {{identifier}} کے لیے مرحلہ لاک ہوگیا۔',
      // SAP کے انکار جو services/sap-integration/errors/map-cpi-error.ts میں پہچانے جاتے ہیں
      sapInsufficientBalance: 'SAP نے وزن مسترد کر دیا — اس لوڈ کے لیے کنٹریکٹ بیلنس ناکافی ہے۔',
      sapContractOverload: 'SAP نے وزن مسترد کر دیا — یہ لوڈ کنٹریکٹ کی باقی قیمت سے زیادہ ہے۔',
      netWeightMismatch: 'خالص وزن مجموعی وزن منفی خالی وزن کے برابر نہیں ہے',
      strapiUnauthorized: 'وزن جمع کرنے کی اجازت نہیں',
      strapiForbidden: 'وزن جمع کرنا ممنوع ہے — ناکافی اختیارات',
      requestTimeout:
        'سرور نے جواب دینے میں بہت دیر لگائی — کنکشن سست ہے۔ ممکن ہے وزن محفوظ ہو گیا ہو یا نہ ہوا ہو۔',
      saveAckTimeout:
        'براہِ کرم وزن کی تصحیح کے صفحے سے وزن چیک کریں۔',
      strapiUnreachable:
        'انٹرنیٹ کنکشن نہیں ہے — وزن سرور تک نہیں بھیجا جا سکا۔',
      flowFailed: 'ویبرج فلو ناکام ہوا',
      weightReadFailed: 'وزن پڑھنا ناکام ہوا',
      gateTestFailed: 'ٹیسٹ گیٹ کھولنا ناکام ہوا',
      // اِن باؤنڈ شپمنٹ اسٹیج گارڈز (incoming-materials/inbound-flow.functions.ts)
      firstWeightStageLocked:
        'پہلا وزن ریکارڈ نہیں کیا جا سکتا — شپمنٹ کی حیثیت "{{status}}" ہے (متوقع: "arrived")',
      secondWeightBeforeFirst: 'پہلے وزن سے پہلے دوسرا وزن ریکارڈ نہیں کیا جا سکتا',
      secondWeightStageLocked:
        'دوسرا وزن ریکارڈ نہیں کیا جا سکتا — شپمنٹ کی حیثیت "{{status}}" ہے (متوقع: "first_weight_done" یا "unloaded")',
      finalizeStageLocked:
        'شپمنٹ کو حتمی شکل نہیں دی جا سکتی — حیثیت "{{status}}" ہے (متوقع: "second_weight_done")',
      exitBeforeSecondWeight:
        'باہر نہیں جا سکتے — شپمنٹ کی حیثیت "{{status}}" ہے۔ پہلے دوسرا وزن ریکارڈ کریں',
      goodsReceiptAlreadyExists: 'اس شپمنٹ کے لیے گڈز رسیٹ پہلے ہی بن چکی ہے',
      // اِن باؤنڈ وزن ریکارڈنگ (api/inbound-shipment/controllers/inbound-shipment.ts recordWeight)
      weightTypeInvalid: 'وزن کی قسم "F" یا "S" ہونی چاہیے',
      fieldMustBePositive: '{{field}} ایک مثبت نمبر ہونا چاہیے',
      invalidShipmentId: 'شپمنٹ کی شناخت غلط ہے',
      poMissingSapNumberForWeight:
        'منسلک پرچیز آرڈر میں SAP پرچیز آرڈر نمبر موجود نہیں — وزن SAP کو نہیں بھیجا جا سکتا',
      sapWeightPushFailed: 'وزن مقامی طور پر ریکارڈ ہوگیا لیکن SAP کو بھیجنا ناکام ہوا: {{reason}}',
      noWeighbridgeTicketForShipment: 'اس شپمنٹ کے لیے کوئی ویبرج ٹکٹ نہیں ملا',
      firstWeightTicketMissingGross: 'پہلے وزن کے ٹکٹ میں کل وزن موجود نہیں',
      shipmentMissingPurchaseOrder: 'شپمنٹ کسی پرچیز آرڈر سے منسلک نہیں',
      noPurchaseOrderLinesForGrn: 'خودکار GRN کے لیے پرچیز آرڈر لائنز نہیں ملیں',
      grnSapPushFailed: 'GRN بن گیا لیکن SAP کو بھیجنا ناکام ہوا: {{reason}}',
      secondWeightGrnFailed: 'دوسرا وزن ریکارڈ ہوگیا لیکن خودکار GRN بنانا ناکام ہوا: {{reason}}',
      // پہلے سے موجود کیز جو سرور میں استعمال ہوتی ہیں لیکن ترجمہ نہیں تھا
      fetchOrderDetailsFailed: 'آرڈر کی تفصیلات حاصل کرنا ناکام ہوا',
      inboundShipmentNotFound: 'اِن باؤنڈ شپمنٹ نہیں ملی',
      platePairingRequired: 'اس گاڑی کی نمبر پلیٹ ریڈنگ نہیں ملی — گیٹ نہیں کھلے گا',
      inboundQrDisabled: 'اس سائٹ پر اِن باؤنڈ رجسٹریشن فعال نہیں ہے',
      purchaseOrderNumberRequired: 'پرچیز آرڈر نمبر درکار ہے',
      purchaseOrderLineRequired: 'منتخب کریں کہ آپ کون سا مال لا رہے ہیں',
      purchaseOrderLineNotFound: 'اس پرچیز آرڈر میں ایسی کوئی لائن نہیں',
      purchaseOrderNotSyncedToSap:
        'پرچیز آرڈر ابھی SAP سے سِنک نہیں ہوا — آمد رجسٹر نہیں ہو سکتی',
      vehicleAlreadyInside:
        'اس گاڑی کی ایک ڈیلیوری پہلے سے کھلی ہے — نئی شروع کرنے سے پہلے باہر جانا ہوگا',
      purchaseOrderNotFound: 'پرچیز آرڈر نہیں ملا',
      purchaseOrderCancelled: 'پرچیز آرڈر منسوخ ہے',
      purchaseOrderClosed: 'پرچیز آرڈر بند ہے',
      sapSalesOrderNumberRequired: 'آرڈر میں SAP سیلز آرڈر نمبر موجود نہیں',
      sapWeightSyncDisabled: 'SAP وزن سنکرونائزیشن غیر فعال ہے',
      secondWeighAlreadyCompleted: 'دوسرا وزن پہلے ہی مکمل ہو چکا ہے',
    },
    /**
     * ہر خرابی پر آپریٹر کو کیا کرنا چاہیے۔ کلیدیں `errors.*` جیسی ہی ہیں
     * (دیکھیں domain/utils/error-remedy.ts) — جس کلید کا اندراج نہ ہو وہ `default` پر واپس آتی ہے۔
     */
    remedies: {
      default: 'آرڈر نمبر لکھ لیں اور IT کو کال کریں۔',
      requestTimeout:
        'ابھی دوبارہ محفوظ نہ کریں۔ پہلے نیچے ریکارڈ شدہ وزن دیکھیں — اگر وزن موجود ہے تو محفوظ ہو چکا ہے۔ نہ ہو تو ۳۰ سیکنڈ انتظار کر کے ایک بار محفوظ کریں۔',
      saveAckTimeout:
        'چیک کرنے سے پہلے دوبارہ محفوظ نہ کریں — دو بار محفوظ کرنے سے وزن ڈپلیکیٹ ہو سکتا ہے۔ وہاں آرڈر نمبر سے تلاش کریں؛ اگر وزن موجود نہ ہو تو ایک بار محفوظ کریں۔',
      fetchZoneFailed:
        'صفحہ ریفریش کریں۔ پھر بھی نہ کھلے تو انٹرنیٹ کنکشن چیک کریں، پھر IT کو کال کریں۔',
      // SAP / کنٹریکٹ
      sapInsufficientBalance:
        'ٹرک کو جانے نہ دیں۔ ڈرائیور سے کہیں کہ کسٹمر کنٹریکٹ بیلنس بڑھوائے، پھر دوبارہ وزن کریں۔',
      sapContractOverload:
        'لوڈ کم کریں، یا کسٹمر سے کنٹریکٹ بڑھوانے کو کہیں، پھر دوبارہ وزن کریں۔',
      contractOverload:
        'لوڈ کم کریں، یا کسٹمر سے کنٹریکٹ بڑھوانے کو کہیں، پھر دوبارہ وزن کریں۔',
      firstWeighFailed: 'دوبارہ کوشش کریں۔ دوسری بار بھی ناکام ہو تو IT کو کال کریں۔',
      secondWeighFailed: 'دوبارہ کوشش کریں۔ دوسری بار بھی ناکام ہو تو IT کو کال کریں۔',
      sapSalesOrderNumberRequired:
        'یہ آرڈر SAP میں بنا ہی نہیں۔ ڈرائیور کو کیوسک بھیجیں تاکہ دوبارہ قطار میں لگے۔',
      sapWeightSyncDisabled: 'IT کو کال کریں — SAP وزن سنکرونائزیشن بند ہے۔',
      // کنیکٹیویٹی
      strapiUnreachable:
        'نیٹ ورک کیبل اور وائی فائی چیک کریں، ۳۰ سیکنڈ انتظار کریں، پھر دوبارہ محفوظ کریں۔ ۳ بار ناکام ہو تو IT کو کال کریں۔',
      controllerRequestFailed:
        'یقینی بنائیں کہ ویٹ برج کنٹرولر باکس چل رہا ہے، ۳۰ سیکنڈ انتظار کریں، پھر دوبارہ کوشش کریں۔ ۳ بار ناکام ہو تو IT کو کال کریں۔',
      weightSubmissionFailed:
        'مرحلہ کھولنے کے لیے ایگزٹ گیٹ کھولیں، پھر اس ٹرک کا دوبارہ وزن کریں۔',
      strapiUnauthorized: 'لاگ آؤٹ کریں اور دوبارہ لاگ ان کریں۔ پھر بھی ہو تو IT کو کال کریں۔',
      strapiForbidden: 'آپ کے اکاؤنٹ کو وزن ریکارڈ کرنے کی اجازت نہیں — سپروائزر سے رابطہ کریں۔',
      // اسکیل ہارڈویئر
      scaleNotClear:
        'یقینی بنائیں کہ پلیٹ فارم بالکل خالی ہے، پھر دوبارہ کوشش کریں۔ پھر بھی صفر نہ آئے تو IT کو کال کریں۔',
      scaleReadFailed:
        'چیک کریں کہ اسکیل ڈسپلے چل رہا ہے اور وزن دکھا رہا ہے، پھر دوبارہ کوشش کریں۔ ۳ بار ناکام ہو تو IT کو کال کریں۔',
      weightReadFailed:
        'چیک کریں کہ اسکیل ڈسپلے چل رہا ہے اور وزن دکھا رہا ہے، پھر دوبارہ کوشش کریں۔ ۳ بار ناکام ہو تو IT کو کال کریں۔',
      // گیٹ
      gateOpenFailed: 'بٹن دوبارہ دبائیں۔ گیٹ پھر بھی نہ ہلے تو اسے ہاتھ سے کھولیں اور IT کو کال کریں۔',
      gateCloseFailed: 'بٹن دوبارہ دبائیں۔ گیٹ پھر بھی نہ ہلے تو اسے ہاتھ سے بند کریں اور IT کو کال کریں۔',
      gateAcknowledgeFailed: 'دیکھیں کہ گیٹ واقعی ہلا ہے یا نہیں۔ نہ ہلا ہو تو IT کو کال کریں۔',
      zkbioUnreachable: 'گیٹ کنٹرولر آف لائن ہے — گیٹ ہاتھ سے کھولیں اور IT کو کال کریں۔',
      zkbioDoorTimeout: 'دیکھیں کہ گیٹ کے راستے میں کچھ نہیں، پھر دوبارہ بند کرنے کی کوشش کریں۔',
      // آرڈر / فلو کی حالت
      orderNotFound: 'ڈرائیور سے آرڈر نمبر کی تصدیق کریں اور دوبارہ درج کریں۔',
      shipmentNotFound: 'ڈرائیور کو کیوسک بھیجیں تاکہ دوبارہ قطار میں لگے۔',
      orderStatusNotProcessing: 'یہ آرڈر ابھی شروع نہیں ہوا۔ پہلے ڈرائیور کو کیوسک بھیجیں۔',
      shipmentNotLoading: 'ٹرک ابھی لوڈ نہیں ہوا۔ پہلے اسے لوڈنگ بے بھیجیں۔',
      firstWeighRequired: 'اس سے پہلے پہلا وزن (خالی ٹرک) کریں۔',
      firstWeighAlreadyCompleted:
        'پہلا وزن پہلے ہی ریکارڈ ہے — اس ٹرک کو دوسرے وزن کے اسکیل پر بھیجیں۔',
      secondWeighAlreadyCompleted:
        'اس ٹرک کا وزن مکمل ہو چکا ہے — اسے ایگزٹ کی طرف جانے دیں۔',
      orderAlreadyWeighed: 'یہ وزن پہلے ہی محفوظ ہے — ٹرک کو جانے دیں۔',
      netWeightInvalid: 'وزن درست نہیں لگ رہے۔ ٹرک کا دوبارہ وزن کریں؛ پھر بھی ہو تو IT کو کال کریں۔',
      netWeightMismatch: 'وزن درست نہیں لگ رہے۔ ٹرک کا دوبارہ وزن کریں؛ پھر بھی ہو تو IT کو کال کریں۔',
      duplicateFlow: 'یہ ٹرک پہلے ہی پروسیس ہو رہا ہے — مکمل ہونے کا انتظار کریں۔',
      zoneLocked: 'اسکیل کھولنے کے لیے ایگزٹ گیٹ کھولیں، پھر دوبارہ کوشش کریں۔',
      zoneBusy: 'آگے والے ٹرک کے اسکیل سے ہٹنے کا انتظار کریں، پھر دوبارہ کوشش کریں۔',
      flowBusy: 'آگے والے ٹرک کے اسکیل سے ہٹنے کا انتظار کریں، پھر دوبارہ کوشش کریں۔',
      bagsWeightVarianceExceeded:
        'ڈرائیور کے ساتھ بیگ دوبارہ گنیں۔ گنتی درست ہو تو ٹرک بھیجنے سے پہلے سپروائزر سے رابطہ کریں۔',
    },
    info: {
      gateOpened: 'گیٹ {{gateCode}} کھل گیا',
      gateClosed: 'گیٹ {{gateCode}} بند ہوگیا',
      orderQueuedLocked: 'آرڈر {{orderNumber}} قطار میں — زون {{weightStage}} کھلنے کا انتظار',
      orderQueued: 'آرڈر {{orderNumber}} پوزیشن {{position}} پر قطار میں',
      flowCompleted: 'ویبرج فلو مکمل — آرڈر {{orderNumber}}، {{weight}} کلو',
      anprAccepted: 'کیمرے کی ریڈنگ قبول ہوگئی',
      scanAccepted: 'QR اسکین قبول ہوگیا',
      gateTestOpened: 'ٹیسٹ گیٹ کامیابی سے کھل گیا',
    },
  },
}
